@if (store.failed()) {
  <app-inline-snackbar
    [type]="snackbarType.ERROR"
    [message]="'documentEditor.openError' | translate"
    [showCloseButton]="false"
  ></app-inline-snackbar>
}

<main class="split">
  <section #stage class="stage">
    <div #styles class="styles"></div>
    <div #preview class="preview"></div>

    @if (store.busy()) {
      <div class="overlay">
        <app-waiting [message]="'documentEditor.opening' | translate"></app-waiting>
      </div>
    }
  </section>

  <aside class="side">
    <app-field-panel
      [fields]="store.fields()"
      [focused]="focused()"
      (changed)="onChanged()"
      (typed)="onTyped($event)"
    />
  </aside>
</main>

@if (chooser(); as open) {
  <div class="scrim" (click)="closeChooser()"></div>

  <div class="chooser" [style.left.px]="open.left" [style.top.px]="open.top">
    @if (open.field.kind === kind.Date) {
      <mat-calendar
        class="docx-date-calendar"
        [selected]="dateOf(open.field.value)"
        [startAt]="dateOf(open.field.value)"
        (selectedChange)="chooseDate($event)"
      />
      <button type="button" class="option unknown-date" (click)="clearDate()">
        {{ 'documentEditor.unknownDate' | translate }}
      </button>
    } @else {
      @for (option of open.field.options; track option.value) {
        <button type="button" class="option" (click)="chooseOption(option.value)">
          {{ option.label }}
        </button>
      }
    }
  </div>
}
